module.exports = __webpack_public_path__ + "media/images/incarcerated_girls/Juvie-Classroom_BW-p-1080-8dcea371c801672eb82950a84b239a4c.jpg";